import { useEffect, useState } from "react"
import Modal from "../../../../../../molecules/Modal"
import Select from "../../../../../../atoms/Select"
import MultiSelect from "../../../../components/MultiSelect"
import RcmpTextArea from "../../../../../../atoms/TextArea"
import Button from "../../../../../../atoms/Button"
import SaveIcon from "../../../../../../../assets/icons/SaveIcon"
import { CardLevel } from "../CardLevel"
import { getCauses, postCause, putRun, getRun, unreleaseRun } from "../../../../../../../services/ciq"
import { set, useForm } from "react-hook-form"
import { ModalInformation } from "../../../../components/ModalInformation"
import intl from "react-intl-universal"
import styles from "./index.module.scss"
import { toast } from "@stardust-ds/react"
import { useAnalyte } from "../../context/analyte"
import RcmpLoading from "../../../../../../atoms/Loading"
import { fnCanAtLeast } from "../../../../../../../utils/permissions"
import { fnisOnlyPermition, fnIsAccessPermition } from "../../../../../../../utils/verifyPermitions"
import useDataApi from "../../../../../../../hooks/useDataApi"

export const Drawer = ({
  isOpen,
  setIsOpen,
  eqpanltrun_nid,
  runNumber,
  analyteName,
  typeAnalyte,
  onSuccessUpdateRun,
}) => {
  const [optCauses, setOptCause] = useState([])
  const [isLoadBtn, setIsLoadBtn] = useState(false)
  const [isConfirmationModal, setIsConfirmationModal] = useState(false)
  const [selectOpts, setSelectOpts] = useState({ label: "", value: "" })
  const [isloadingConclusion, setIsLoadingConclusion] = useState(false)
  const [isloadingDraft, setIsLoadingDraft] = useState(false)
  const [user, setUser] = useState(null)
  const [infoLaunchs, setInfoLaunchs] = useState([])
  const [loading, setIsloading] = useState(true)
  const [changedForm, setChangedForm] = useState(false)
  const [oRun, setORun] = useState(null)
  const [oError, setOError] = useState({
    bcauses: false,
    bconclusion: false,
    bimmediate: false,
  })

  const [optDefault, setOptDefault] = useState({ label: "", value: "" })
  const [causeDefault, setCauseDefault] = useState([])

  const analyteContext = useAnalyte()
  const [unrelaseRunRes, fnUnreleaseRunReq] = useDataApi(unreleaseRun)

  const opts = [
    { label: intl.get("ciq.status_race.approved"), value: 3 },
    { label: intl.get("ciq.status_race.disapproved"), value: 2 },
  ]

  const getListCause = async () => {
    try {
      const response = await getCauses()

      const newData = response.data.data.map((item) => ({
        id: item.cause_nid,
        label: item.cause_cdescription,
        value: item.cause_cdescription,
      }))

      setOptCause(newData)
    } catch (err) {
      console.log(err)
    }
  }

  const postOneMoreCause = async (cause) => {
    try {
      setIsLoadBtn(true)
      if (cause === "") return
      await postCause({ cause_cdescription: cause })

      await getListCause()
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadBtn(false)
    }
  }

  const { register, handleSubmit, reset, setValue } = useForm()

  const onSubmit = async (data) => {
    const newData = {
      ...data,
      eqpanltrun_cimmediate_action: data.eqpanltrun_cimmediate_action?.trim(),
      eqpanltrun_cconclusion: data.eqpanltrun_cconclusion?.trim(),
    }

    /*
      PENDING = 1;
      REJECTED = 2;
      RELEASED = 3;
    */

    try {
      if (data.eqpanltrun_draft) {
        setIsLoadingDraft(true)
      } else {
        setIsLoadingConclusion(true)
      }

      const bIsWestgardRoleReject = oRun?.eqpanltrun_launches
        .flatMap((item) => item.eqpanltlaunch_awestgard_rules)
        .some((item) => item.eqpanltlnchwgr_eaction.includes("R"))

      if (bIsWestgardRoleReject) {
        if (
          !newData.eqpanltrun_cimmediate_action &&
          !newData.eqpanltrun_cconclusion &&
          newData.eqpanltrun_causes.length === 0
        ) {
          setOError((prev) => ({
            ...prev,
            bcauses: true,
            bconclusion: true,
            bimmediate: true,
          }))
          return
        } else {
          setOError((prev) => ({
            ...prev,
            bcauses: false,
            bconclusion: false,
            bimmediate: false,
          }))
        }

        // console.log(newData)
        if (!newData.eqpanltrun_cimmediate_action) {
          setOError((prev) => ({ ...prev, bimmediate: true }))
          return
        } else {
          setOError((prev) => ({ ...prev, bimmediate: false }))
        }
        if (!newData.eqpanltrun_cconclusion) {
          setOError((prev) => ({ ...prev, bconclusion: true }))
          return
        } else {
          setOError((prev) => ({ ...prev, bconclusion: false }))
        }
        if (newData.eqpanltrun_causes.length === 0) {
          setOError((prev) => ({ ...prev, bcauses: true }))
          return
        } else {
          setOError((prev) => ({ ...prev, bcauses: false }))
        }
      }

      await putRun(eqpanltrun_nid, newData)

      toast({
        type: "success",
        title: intl.get("ciq.drawer.toast.title_success"),
        description: data.eqpanltrun_draft
          ? intl.get("ciq.drawer.toast.draft_success")
          : intl.get("ciq.drawer.toast.description_success"),
      })

      if (data.eqpanltrun_draft === false) {
        setIsOpen(false)

        analyteContext?.setReload?.((prev) => !prev)
        onSuccessUpdateRun?.()
      }
    } catch (err) {
      const cErrorMessage = err?.response?.data?.message

      if (cErrorMessage?.toLowerCase() === "run not found") {
        toast({
          type: "error",
          title: intl.get("generic_error"),
          description: intl.get("ciq.drawer.toast.run_not_found", {
            run: runNumber,
          }),
        })
        return
      }

      toast({
        type: "error",
        title: intl.get("generic_error"),
        description: cErrorMessage,
      })
    } finally {
      setIsLoadingConclusion(false)
      setIsLoadingDraft(false)
      setChangedForm(false)
    }
  }

  const fetchRun = async () => {
    try {
      setIsloading(true)
      const response = await getRun(eqpanltrun_nid)
      setORun(response?.data?.data || null)
      setUser(response.data.data.eqpanltrun_user)

      const data = response.data.data.eqpanltrun_launches.map((item) => ({
        ...item,
        isDataLevel: true,
        eqpanltrun_drelease: response.data.data.eqpanltrun_drelease,
        type_analyte: typeAnalyte,
      }))

      if (response.data.data.eqpanltrun_raw_status === "Pending") {
        setOptDefault([])
      } else {
        setOptDefault({
          label:
            response.data.data.eqpanltrun_raw_status === "Approved"
              ? intl.get("ciq.status_race.approved")
              : intl.get("ciq.status_race.disapproved"),
          value: response.data.data.eqpanltrun_raw_status === "Approved" ? 3 : 2,
        })
      }

      const levels = [1, 2, 3]

      const thereIsLevels = data.map((it) => it.eqpanltlaunch_elevel)

      const thereIsNotLevels = levels.filter((it) => !thereIsLevels.includes(it))

      thereIsNotLevels.forEach((level) => {
        data.push({ eqpanltlaunch_elevel: level, isDataLevel: false })
      })

      const order = data.sort((a, b) => a.eqpanltlaunch_elevel - b.eqpanltlaunch_elevel)

      setValue("eqpanltrun_cconclusion", response.data.data.eqpanltrun_cconclusion)

      setValue(
        "eqpanltrun_cimmediate_action",
        response.data.data.eqpanltrun_cimmediate_action,
      )

      const causes = response.data.data.eqpanltrun_causes.map((item) => ({
        label: item.cause_cdescription,
        value: item.cause_nid,
      }))

      setValue(
        "eqpanltrun_causes",
        causes.map((item) => item.value),
      )

      setCauseDefault(causes)

      setInfoLaunchs(order)
    } catch (err) {
      console.log(err)
    } finally {
      setIsloading(false)
    }
  }

  useEffect(() => {
    getListCause()
    fetchRun()
  }, [])

  const closeModal = () => {
    if (changedForm) {
      setIsConfirmationModal(true)
    } else {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    if (unrelaseRunRes.loading || !unrelaseRunRes.done) return


    if (unrelaseRunRes.data) {
      toast({
        type: "success",
        title: intl.get("ciq.drawer.toast.title_success"),
        description: intl.get("ciq.drawer.toast.description_success"),
      })
      fetchRun()
      analyteContext?.setReload?.((prev) => !prev)
      onSuccessUpdateRun?.()
      return
    }

    if (unrelaseRunRes.error) {
      toast({
        type: "error",
        title: "Erro",
        description: unrelaseRunRes.error?.response?.data?.message,
      })
      return
    }

  }, [unrelaseRunRes])

  const handleUnreleaseRun = async () => {
    if (!eqpanltrun_nid) return
    await fnUnreleaseRunReq(eqpanltrun_nid)
  }

  const isAccessUpdateRun = fnIsAccessPermition("update-run")
  const isOnlyView = !isAccessUpdateRun
  const isPermition = fnisOnlyPermition("access-ciq") || isOnlyView

  useEffect(() => {
    if (isPermition) {
      return
    } else if (
      fnCanAtLeast("create-edit-launch", "internal-quality-control") &&
      !fnCanAtLeast("update-run", "internal-quality-control")
    ) {
      window.location.href = "/"
      return
    }
  }, [optCauses])

  const bIsRunApproved = oRun?.eqpanltrun_status === "Approved"
  const bIsRunDisapproved = oRun?.eqpanltrun_status === "Rejected"

  return (
    <>
      <Modal
        isOpen={isOpen}
        positionLeft="100%"
        translateX="-100%"
        isDrawer
        maxHeight="100vh"
        onRequestClose={() => {
          if (bIsRunApproved || bIsRunDisapproved) {
            setIsOpen(false)
            return
          }

          closeModal()
        }}
        closeOnClickOutside={true}
        height="100%"
      >
        <Modal.Header
          style={{
            justifyContent: "flex-start",
            padding: "0.5rem",
          }}
          onClose={() => {
            if (bIsRunApproved || bIsRunDisapproved) {
              setIsOpen(false)
              return
            }

            closeModal()
          }}
        >
          <h1 className={styles.titleModal}>{intl.get("ciq.info_release")}</h1>
        </Modal.Header>

        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "30rem",
              }}
            >
              <RcmpLoading bShow={true} size={40} />
            </div>
          ) : (
            <Modal.Content
              style={{
                paddingInline: "1rem",
              }}
            >
              <h2 className={styles.nameAnalyte}>
                {intl.get("ciq.exame_analytes")}: {analyteName}
              </h2>
              <h2 className={styles.running}>
                {intl.get("ciq.race")} Nº: {runNumber}
              </h2>

              <div className={styles.wrapperCardLevel}>
                {infoLaunchs?.map((item, index) => {
                  if (item.eqpanltlaunch_elevel === 1) {
                    return (
                      <CardLevel
                        item={item}
                        key={index}
                        level={intl.get("ciq.level_one")}
                        color="#0066FF"
                        user={user}
                        isDisabled={!item.isDataLevel}
                      />
                    )
                  } else if (item.eqpanltlaunch_elevel === 2) {
                    return (
                      <CardLevel
                        item={item}
                        key={index}
                        level={intl.get("ciq.level_two")}
                        color="#B83EE3"
                        user={user}
                        isDisabled={!item.isDataLevel}
                      />
                    )
                  } else if (item.eqpanltlaunch_elevel === 3) {
                    return (
                      <CardLevel
                        item={item}
                        key={index}
                        level={intl.get("ciq.level_three")}
                        color="#89C22C"
                        user={user}
                        isDisabled={!item.isDataLevel}
                      />
                    )
                  }
                })}
              </div>

              <div className={styles.wrapperInputs}>
                <Select
                  autoComplete="off"
                  label={intl.get("ciq.release")}
                  options={opts}
                  placeholder={intl.get("ciq.select")}
                  searchable={false}
                  width="100%"
                  disabled={bIsRunApproved || bIsRunDisapproved || isPermition}
                  defaultValue={optDefault}
                  className={styles.select}
                  onSelect={(e) => {
                    if (bIsRunApproved) return
                    if (e === null) {
                      setSelectOpts({ label: "", value: "" })
                      setChangedForm(true)
                      return
                    }

                    if (e.value === "") return
                    setChangedForm(true)

                    setSelectOpts(e)
                    setValue("eqpanltrun_status_nid", e.value)
                  }}
                  clearable={oRun?.eqpanltrun_raw_status?.toLowerCase() === "pending"}
                />

                <MultiSelect
                  autoComplete="off"
                  label={intl.get("ciq.cause")}
                  placeholder={intl.get("ciq.select")}
                  isDisabled={bIsRunApproved || bIsRunDisapproved || isPermition}
                  isloading={isLoadBtn}
                  onSelect={(e) => {
                    setChangedForm(true)
                    setValue(
                      "eqpanltrun_causes",
                      e.map((item) => item?.id ? item.id : item.value),
                    )
                  }}
                  opts={optCauses}
                  onCreateOption={postOneMoreCause}
                  bIsEdit // isError={fnIsError(errors?.anlt_result_options)}
                  // messageError={errors?.anlt_result_options?.message}
                  isError={oError.bcauses}
                  type="semi-quantitativo"
                  defaultOptValue={causeDefault}
                />

                <RcmpTextArea
                  data-error={oError.bimmediate ? "error" : "not-error"}
                  placeholder={intl.get("ciq.type_here")}
                  className={`${styles.itemFlex}`}
                  disabled={bIsRunApproved || bIsRunDisapproved || isPermition}
                  label={intl.get("ciq.immidiate_action")}
                  {...register("eqpanltrun_cimmediate_action")}
                  onChange={() => setChangedForm(true)}
                />
                <RcmpTextArea
                  placeholder={intl.get("ciq.type_here")}
                  data-error={oError.bconclusion ? "error" : "not-error"}
                  disabled={bIsRunApproved || bIsRunDisapproved || isPermition}
                  className={`${styles.itemFlex}`}
                  label={intl.get("ciq.conclusion")}
                  {...register("eqpanltrun_cconclusion")}
                  onChange={() => setChangedForm(true)}
                />
              </div>
            </Modal.Content>
          )}
          <div className={styles.wrapperBtn}>
            <Button
              style={{ textTransform: "capitalize" }}
              type="button"
              variant="outline"
              onClick={() => {
                if (bIsRunApproved || bIsRunDisapproved) {
                  setIsOpen(false)
                  return
                }

                closeModal()
              }}
            >
              {intl.get("ciq.btn_cancel")}
            </Button>
            {!loading && (
              <>
                <Button
                  style={{ textTransform: "capitalize" }}
                  type="submit"
                  variant="outline"
                  disabled={selectOpts.value !== "" || isPermition || isloadingDraft || bIsRunApproved || bIsRunDisapproved}
                  isLoading={isloadingDraft}
                  onClick={() => {
                    setValue("eqpanltrun_draft", true)
                    setChangedForm(false)
                  }}
                >
                  <SaveIcon stroke="#6cb6ec" />
                  {intl.get("ciq.save_draft")}
                </Button>
                {!bIsRunApproved && !bIsRunDisapproved ? (
                  <Button
                    style={{ textTransform: "capitalize" }}
                    type="submit"
                    disabled={
                      selectOpts.value === "" || isPermition || isloadingConclusion
                    }
                    onClick={() => {
                      setValue("eqpanltrun_draft", false)
                    }}
                    isLoading={isloadingConclusion}
                  >
                    <SaveIcon />
                    {intl.get("ciq.conclude")}
                  </Button>
                ) : (
                  <Button
                    style={{ textTransform: "capitalize" }}
                    type="button"
                    disabled={isPermition || unrelaseRunRes.loading}
                    isLoading={unrelaseRunRes.loading}
                    onClick={handleUnreleaseRun}
                  >
                    {intl.get("ciq.undo")}
                  </Button>
                )}
              </>
            )}
          </div>
        </form>
      </Modal>

      {isConfirmationModal && (
        <ModalInformation
          bgBtn="#1ECB4F"
          title="Informações Lançamentos"
          description={intl.get("ciq.changes_not_save")}
          onCancel={() => {
            setIsConfirmationModal(false)
          }}
          onClose={() => {
            setIsConfirmationModal(false)
            reset()
            setIsOpen(false)
          }}
        />
      )}
    </>
  )
}
